import { Container, Box } from '@hover/blueprint';
import React from 'react';
import { useInterSectionObserver } from '../../hooks';
import { HeaderDescription } from '../common';

interface Props {
  setCurrentSection: React.Dispatch<React.SetStateAction<string>>;
}

const OurPeople: React.FC<Props> = ({ setCurrentSection }) => {
  const ourPeopleRef = useInterSectionObserver(
    isIntersecting => {
      if (isIntersecting) {
        setCurrentSection('Our People');
      }
    },
    {
      rootMargin: '0px',
      threshold: 1,
      root: null,
    },
  );

  return (
    <Container
      ref={ourPeopleRef.elementRef}
      maxW="5xl"
      position="relative"
      pt={97}
      pb={97}
    >
      <Box
        id="careers-our-people"
        position={{ desktop: 'absolute' }}
        display={{ base: 'none', desktop: 'block' }}
        w={0}
        h={0}
        top="200px"
      />
      <HeaderDescription
        heading="Our people"
        body="HOVER's employees are our top priority and drive our success.
            That's why we invest in employee's personal and
            professional growth, fund and prioritize employee-led diversity and
            inclusion work, and support work-life balance. We are committed to
            building and sustaining a company culture where all HOVERites
            experience a sense of belonging, are inspired by their peers, and
            love their work."
      />
    </Container>
  );
};

export default OurPeople;
